import { AVAILABLE_LOCALES } from "@/modules/i18n/constants"

export const isJobAdsSearchUrl = (url: string): boolean => {
  const [pathname] = url.split("?")
  return AVAILABLE_LOCALES.some(locale => new RegExp(`^/${locale}/job-offers$`).test(pathname))
}
